/// <reference types="./new_style_guideline.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $style_guideline from "../../../../common/data/style_guideline.mjs";
import { NewStyleGuideline } from "../../../../common/data/style_guideline.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $model from "../../../data/model.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $s from "../../../frontend/view/styles/content_library.mjs";
import { toList } from "../../../gleam.mjs";

export function view(model, update) {
  let state = $bright.state(model);
  let _block;
  if (update) {
    _block = "Edit the style guideline";
  } else {
    _block = "Add a style guideline";
  }
  let text = _block;
  let $ = state.organization.new_style_guideline;
  let name = $.name;
  let content = $.content;
  let disabled = (name === "") || (content === "");
  return $l.fragment(
    toList([
      $s.new_question_wrapper(
        toList([
          $e.on_submit(
            (_) => { return new $msg.UserSubmittedNewStyleGuideline(); },
          ),
        ]),
        toList([
          $s.question_title(toList([]), toList([$h.text(text)])),
          $input.input(
            toList([
              $input.label("Name"),
              $input.value(name),
              $input.on_input(
                (name) => {
                  return new $msg.UserUpdatedNewStyleGuidelineName(name);
                },
              ),
            ]),
          ),
          $input.input(
            toList([
              $input.multiline(),
              $input.label("Content"),
              $input.value(content),
              $input.on_input(
                (content) => {
                  return new $msg.UserUpdatedNewStyleGuidelineContent(content);
                },
              ),
            ]),
          ),
          $l.row(
            toList([$l.justify("end")]),
            toList([]),
            toList([
              $button.primary(
                toList([$a.type_("submit"), $a.disabled(disabled)]),
                toList([$h.text("Submit")]),
              ),
            ]),
          ),
        ]),
      ),
    ]),
  );
}
